export interface SelectOption {
  value: string
  label: string
}

export interface SelectProps {
  options: SelectOption[]
  onChange: (value: string | null, option: SelectOption | null) => void
  value?: string | null
  placeholder?: string
  clearable?: boolean
  searchable?: boolean
  isLoading?: boolean
  error?: boolean
}
